import React from 'react';
import InlinePreview from '../shared/InlinePreview';
import ImagePreview from './Preview';
const Image = React.forwardRef((props, ref) => {
    const { src, title, alt, children, ...restProps } = props;
    return (React.createElement(InlinePreview, Object.assign({}, restProps, { ref: ref, title: title, preview: React.createElement(ImagePreview, { src: src, title: title, alt: alt }) }), children));
});
Image.displayName = 'Image';
export default React.memo(Image);
//# sourceMappingURL=index.js.map